export default "__VITE_ASSET__BCiBY7PQ__"